module.exports = __webpack_public_path__ + "img/1.5daa8d29.png";